import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PerfilPage from "../pages/perfil/page";
import EmpresaPage from "../pages/empresa/page";
import AdminPage from "../pages/admin/page";
import AdminLoginPage from "../pages/admin/login/page";
import BibliotecaEstrategicaPage from "../pages/biblioteca-estrategica/page";
import GuiaCVEuropeoPage from "../pages/guia-cv-europeo/page";
import GuiaEntrevistasPage from "../pages/guia-entrevistas-internacionales/page";
import GuiaClavesAlemaniaPage from "../pages/guia-claves-alemania/page";
import GuiaClaveSuizaPage from "../pages/guia-claves-suiza/page";
import GuiaClavePaisesBajosPage from "../pages/guia-claves-paises-bajos/page";
import GuiaClavesAustriaPage from "../pages/guia-claves-austria/page";
import GuiaClaveBelgicaPage from "../pages/guia-claves-belgica/page";
import AvisoLegalPage from "../pages/aviso-legal/page";
import PoliticaPrivacidadPage from "../pages/politica-privacidad/page";
import PoliticaCookiesPage from "../pages/politica-cookies/page";
import PublicLayout from "../components/feature/PublicLayout";

const routes: RouteObject[] = [
  // Páginas públicas — con Navbar global
  {
    path: "/",
    element: (
      <PublicLayout noTopPadding>
        <Home />
      </PublicLayout>
    ),
  },
  {
    path: "/inicio",
    element: (
      <PublicLayout noTopPadding>
        <Home />
      </PublicLayout>
    ),
  },
  {
    path: "/biblioteca-estrategica",
    element: (
      <PublicLayout>
        <BibliotecaEstrategicaPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-cv-europeo",
    element: (
      <PublicLayout>
        <GuiaCVEuropeoPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-entrevistas-internacionales",
    element: (
      <PublicLayout>
        <GuiaEntrevistasPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-claves-alemania",
    element: (
      <PublicLayout>
        <GuiaClavesAlemaniaPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-claves-suiza",
    element: (
      <PublicLayout>
        <GuiaClaveSuizaPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-claves-paises-bajos",
    element: (
      <PublicLayout>
        <GuiaClavePaisesBajosPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-claves-austria",
    element: (
      <PublicLayout>
        <GuiaClavesAustriaPage />
      </PublicLayout>
    ),
  },
  {
    path: "/guia-claves-belgica",
    element: (
      <PublicLayout>
        <GuiaClaveBelgicaPage />
      </PublicLayout>
    ),
  },
  {
    path: "/aviso-legal",
    element: (
      <PublicLayout>
        <AvisoLegalPage />
      </PublicLayout>
    ),
  },
  {
    path: "/politica-privacidad",
    element: (
      <PublicLayout>
        <PoliticaPrivacidadPage />
      </PublicLayout>
    ),
  },
  {
    path: "/politica-cookies",
    element: (
      <PublicLayout>
        <PoliticaCookiesPage />
      </PublicLayout>
    ),
  },
  // Páginas privadas — ahora también con Navbar global
  { 
    path: "/perfil", 
    element: (
      <PublicLayout>
        <PerfilPage />
      </PublicLayout>
    )
  },
  { 
    path: "/empresa", 
    element: (
      <PublicLayout>
        <EmpresaPage />
      </PublicLayout>
    )
  },
  // Admin
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin", element: <AdminPage /> },
  // 404
  { path: "*", element: <NotFound /> },
];

export default routes;